import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'aura-dialog-layout',
  templateUrl: './dialog.component.html',
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogLayoutAuraComponent {
  readonly dialogRef = inject(MatDialogRef<this>);
  readonly title = input<string>();
  readonly hideActions = input<boolean>(false);
  readonly hideCancel = input<boolean>(false);

  onClose() {
    this.dialogRef.close(false);
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }
}
